export const formatMonthStartDate = (year, month) => {
  if (!year || !month) {
    return '';
  }

  const date = new Date(year, month - 1, 1);
  const monthValue = String(date.getMonth() + 1).padStart(2, '0');
  const dayValue = String(date.getDate()).padStart(2, '0');

  return `${date.getFullYear()}-${monthValue}-${dayValue}`;
};

export const normalizeInvoiceStatus = (invoice) => {
  if (!invoice) {
    return 'DRAFT';
  }

  if (invoice.is_reversed) {
    return 'REVERSED';
  }

  const rawStatus = String(invoice.invoice_status || '').trim().toUpperCase();
  if (['DRAFT', 'SENT', 'PAID'].includes(rawStatus)) {
    return rawStatus;
  }

  return 'DRAFT';
};

export const isInvoiceEditable = (invoice, normalizeStatus = normalizeInvoiceStatus) => (
  normalizeStatus(invoice) === 'DRAFT' && !invoice?.is_reversed
);

export const getInvoiceStatusMeta = (invoice, normalizeStatus = normalizeInvoiceStatus, editable = isInvoiceEditable(invoice, normalizeStatus)) => {
  const status = normalizeStatus(invoice);
  const labelMap = {
    DRAFT: 'Draft',
    SENT: 'Sent',
    PAID: 'Paid',
    REVERSED: 'Reversed'
  };

  const meta = {
    status,
    label: labelMap[status] || status,
    editable,
    className: 'bg-gray-100 text-gray-700'
  };

  if (status === 'DRAFT') {
    meta.className = editable ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-700';
  } else if (status === 'SENT') {
    meta.className = 'bg-blue-100 text-blue-800';
  } else if (status === 'PAID') {
    meta.className = 'bg-green-100 text-green-800';
  } else if (status === 'REVERSED') {
    meta.className = 'bg-red-100 text-red-700';
  }

  return meta;
};
